<template>
	<div class="wrapper">
		<div class="inner">
			<section class="contents">
				<h1 class="titleImg">
					<picture>
						<source srcset="../assets/img/kurehaTest/titleSet_pc.svg" media="(min-width: 901px)" width="998" height="900" />
						<img
							src="../assets/img/kurehaTest/titleSet_sp.svg"
							width="767"
							height="1005"
							alt="クレハ検定 環境と社会への取り組み編"
						/>
					</picture>
				</h1>
				<p class="desc">
					意外と知られていない、クレハの<br
						class="u-ds-sp"
					/>サステナビリティに関する取り組みや<br />クレハ製品と環境・社会問題との<br
						class="u-ds-sp"
					/>関係性をクイズにしました。<br />問題は全5問。<br class="u-ds-sp" />全問正解を目指してクレハマスターの<br
						class="u-ds-sp"
					/>称号を手に入れよう！
				</p>
				<div class="linkBtn u-rock">
					<router-link class="linkBtn_link" to="/kureha-quiz"
						>腕試しスタート
						<img class="linkBtn_arrow" src="../assets/img/kurehaTest/arrow.svg" alt="" width="50" height="17.5"
					/></router-link>
				</div>
				<div class="warning">
					<p class="warning_box">操作上のお願い</p>
					<p class="warning_desc u-justify">
						回答中にブラウザの「戻る」ボタンおよびリロードを使用しないでください。<br
							class="u-ds-pc"
						/>もう一度回答したい場合は、すべての回答を終えてから、再度挑戦してください。
					</p>
				</div>
			</section>
		</div>
	</div>
</template>
<script>
export default {
	name: 'kureha-quiz-test',
	components: {},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
@use 'sass:math';
@use 'sass:string';
//pxをvw/vhに変換
@function vw($size, $viewport: 768) {
	$rate: math.div(100, $viewport);
	@return $rate * $size * 1vw;
}
@function vw_lg($size, $viewport: 1366) {
	$rate: math.div(100, $viewport);
	@return $rate * $size * 1vw;
}

p,
h1,
h2,
ul,
li,
a {
	margin: 0;
}

img {
	vertical-align: top;
}
@mixin pc {
	@media print, screen and (min-width: 901px) {
		@content;
	}
}
.u-ds-sp {
	@include pc {
		display: none;
	}
}
.u-ds-pc {
	display: none;
	@include pc {
		display: block;
	}
}

// 文末揃え
.u-justify {
	text-align: justify;
	text-justify: inter-character; //for Firefox
}

.u-rock {
	font-family: 'RocknRoll One', sans-serif;
}
.wrapper {
	padding: vw(240) vw(40) vw(60);
	background-color: #3fa300;
	overflow: hidden;
	@include pc {
		padding: 160px 0 120px;
	}
}
.inner {
	padding: 10px;
	background-color: #3fa300;
	background-image: repeating-linear-gradient(-45deg, #fff, #fff 3px, transparent 0, transparent 6px);
	box-shadow: 6px 6px 12px 3px rgba(#000000, 0.2);
	border-radius: 20px;
	@include pc {
		position: relative;
		width: 80%;
		max-width: 1030px;
		padding: 15px;
		background-image: repeating-linear-gradient(-45deg, #fff, #fff 4px, transparent 0, transparent 8px);
		box-shadow: 6px 6px 12px 3px rgba(#000000, 0.2);
		margin-inline: auto;
		border-radius: 25px;
		outline: 20px solid #fff;
		box-shadow: 26px 26px 24px 3px rgba(#000000, 0.2);
	}
}

.contents {
	position: relative;
	background-color: #fff;
	border-radius: 20px;
	padding-bottom: 60px;
	@include pc {
		border-radius: 25px;
		padding-bottom: 70px;
	}
	.titleImg {
		position: relative;
		width: vw(776);
		margin: 0 auto;
		// transform: translate(vw(-64), vw(-202));
		left: 50%;
		transform: translate(-50%, -20%);
		@include pc {
			// width: vw_lg(1182);
			width: 95%;
			max-width: 1182px;
			transform: translate(-50%, -11%);
			// transform: translate(-1.5%, -14.5%);
		}
		img {
			width: 100%;
		}
	}
	.desc {
		margin-top: vw(-142);
		padding: 0 vw(60);
		font-size: 14px;
		font-weight: bold;
		text-align: center;
		line-height: calc(55 / 28);
		@include pc {
			margin-top: max(vw_lg(-30), -30px);
			padding: 0 20px;
			font-size: 22px;
			line-height: 2;
			letter-spacing: 0.1em;
		}
	}
}

.linkBtn {
	position: relative;
	width: 83%;
	margin: 2em auto 0;
	font-size: 20px;
	color: #00797f;
	font-weight: 400;
	border-radius: 100vmax;
	letter-spacing: 0.1em;
	transform: translateX(-0.1em);
	@include pc {
		transform: none;
		width: 460px;
		font-size: 35px;
	}

	&::after {
		content: '';
		display: block;
		position: absolute;
		right: -5px;
		bottom: -5px;
		z-index: 0;
		width: 100%;
		height: 100%;
		background-color: currentColor;
		border-radius: 100vmax;
		@include pc {
			right: -10px;
			bottom: -10px;
		}
	}

	&_link {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		padding: 0.05em 0 0.15em 0.1em;
		width: 100%;
		height: 100%;
		z-index: 1;
		background-color: #ffe200;
		// background-color: red;
		border-radius: 100vmax;
		@include pc {
			justify-content: flex-start;
			padding: 0.05em 0 0.15em 1.6em;
			box-sizing: border-box;
		}
		@media (hover: hover) {
			&:hover {
				opacity: 1 !important;
				background-color: #545454 !important;
			}
		}
	}
	&_arrow {
		width: 1.25em;
		margin-left: 2.3em;
		@include pc {
			width: 1.5em;
			margin-left: 1em;
			margin-top: 0.3em;
		}
	}
}

.warning {
	margin-top: 40px;
	padding: 0 vw(50);
	@include pc {
		display: flex;
		margin: 75px auto 0;
		justify-content: center;
		padding: 0 20px;
	}
	&_box {
		display: inline-block;
		padding: 0.4em 0.6em;
		line-height: 1;
		letter-spacing: 0.05em;
		background-color: #d00012;
		font-size: 12px;
		color: #fff;
		font-weight: bold;
		@include pc {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			flex: 0 0 auto;
			margin-right: 1em;
			height: 2.5em;
			padding: 0 1em;
			font-size: 20px;
		}
	}
	&_desc {
		margin-top: 0.25em;
		color: #d00012;
		font-size: 11px;
		line-height: calc(36 / 22);
		font-weight: bold;
		@include pc {
			margin-top: -5px;
			font-size: 18px;
			line-height: calc(28 / 18);
			letter-spacing: 0.1em;
			// white-space: nowrap;
		}
	}
}
</style>
